













import {Component, Vue, Prop} from 'vue-property-decorator';

@Component({
  name: 'product-list-size-select'
})

export default class extends Vue {
  @Prop({required: true}) readonly dataSource: string;

  private get sizes(): Array<number> {
    return window.Config['catalog']['page_size_options'];
  }

  private get pageSize(): number {
    return Number(this.$store.getters[`${this.dataSource}/pageSize`]);
  }

  private updatePageSize(e): void {
    this.$store.dispatch(`${this.dataSource}/updatePageSize`, e.target.value);
  }
}
